import React,{ FC, FormEvent, useCallback, useEffect, useState } from "react";
import { FormModal } from "../Modal";
import {
  Stack,
  Label,
  TextField,
  IconButton,
  Text,
  IStackTokens,
  IPersonaProps,
} from "@fluentui/react";
import { t } from "i18next";
import { colorPallete } from "../../../assets/color";
import { MailTextBox } from "../../MailTextBox";
import { VerticalStack, HorizontalStack } from "../../Stack";
import { ProjectService } from "../../../services/ProjectService";
import Popup from "../../Popup/Popup";
import ErrorIcon from "../../../assets/Icons/svg/errorIcon";
import SuccessIcon from "../../../assets/Icons/svg/successIcon";

const buttonStackStyles = {
  root: {
    padding: "1%",
  },
};
const horizontalStackTokens: IStackTokens = {
  childrenGap: "2%",
};

export const EditProjectModal: FC<any> = (props) => {
  const [folderName, setFolderName] = useState("");
  const [originalFolderName, setOriginalFolderName] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const [folderNameError, setFolderNameError] = useState(false);
  const [projectExist, setProjectExist] = useState(false);
  const [projectOwner, setProjectOwner] = useState("");
  const [originalProjectOwner, setOriginalProjectOwner] = useState("");
  const [projectOwnerError, setProjectOwnerError] = useState(false);
  const [currentSelectedItems, setCurrentSelectedItems] = useState<
    IPersonaProps[]
  >([]);
  const [originalCurrentSelectedItems, setOriginalCurrentSelectedItems] = useState<
    IPersonaProps[]
  >([]);
  const [errorMesssage, setErrorMesssage] = useState("");

  const [textFields, setTextFields] = useState<string[]>([]);
  const [originalTextFields, setOriginalTextFields] = useState<string[]>([]);
  const [counterPartyError, setCounterPartyError] = useState(false);

  const [projectValue, setProjectValue] = useState("");
  const [originalProjectValue, setOriginalProjectValue] = useState("");

  const [completionDate, setCompletionDate] = useState("");
  const [originalCompletionDate, setOriginalCompletionDate] = useState("");

  const [description, setDescription] = useState("");
  const [originalDescription, setOriginalDescription] = useState("");

  const [clientNumber, setClientNumber] = useState<number>();
  const [originalClientNumber, setOriginalClientNumber] = useState<number>();
  const [clientMatter, setClientMatter] = useState<number>();
  const [originalClientMatter, setOriginalClientMatter] = useState<number | undefined>(undefined);

  useEffect(() => {
    setDescription(props.description);
    setOriginalDescription(props.description);
  }, [props.description]);

  useEffect(() => {
    setFolderName(props.folderName);
    setOriginalFolderName(props.folderName);
  }, [props.folderName]);

  useEffect(() => {
    if(props.counterParties){
      var counterParties = props.counterParties.split(";");
      setTextFields(counterParties);
      setOriginalTextFields(counterParties);
    }
  }, [props.counterParties]);

  useEffect(() => {
    setClientNumber(props.clientNumber);
    setOriginalClientNumber(props.clientNumber);
  }, [props.clientNumber]);

  useEffect(() => {
    setClientMatter(props.clientMatter);
    setOriginalClientMatter(props.clientMatter);
  }, [props.clientMatter]);

  useEffect(() => {
    const dateObject = new Date(props.completionDate);
    const formatDate = `${dateObject.getFullYear()}-${(
      dateObject.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${dateObject.getDate().toString().padStart(2, "0")}`;
    setCompletionDate(formatDate);
    setOriginalCompletionDate(formatDate);
  }, [props.completionDate]);

  useEffect(() => {
    setOriginalProjectOwner(projectOwner);
  }, [projectOwner]);

  useEffect(() => {
    setOriginalCurrentSelectedItems(currentSelectedItems);
  }, [currentSelectedItems]);

  useEffect(() => {
    const value = props.projectValue || 0
    setProjectValue(String(value));
    setOriginalProjectValue(String(value));
  }, [props.projectValue]);

  useEffect(() => {
    if (props.projectOwner) {
      setProjectOwner(props.projectOwner);
    }
  }, [props.projectOwner]);

  const addCounterPartyField = () => {
    setTextFields([...textFields, ""]);
  };

  const updatedTextFields = [...textFields];
  const removeTextField = (index: number) => {
    updatedTextFields.splice(index, 1);
    setTextFields(updatedTextFields);
  };

  useEffect(() => {}, [textFields]);

  const handleTextFieldChange = (index: number, value: string) => {
    updatedTextFields[index] = value;
    if (value.length === 0) {
      setCounterPartyError(true);
    } else {
      setCounterPartyError(false);
    }

    setTextFields(updatedTextFields);
  };

  const NumberWithCommas = (number: string) => {
    const addCommas = (num: string) => {
      const cleanedStr = num.replace(/\D/g, "");
      return "$" + cleanedStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    const formattedNumber = addCommas(number);
    return formattedNumber;
  };

  const onChangeProjectValue = useCallback(
    (
      event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
      setProjectValue(newValue ?? "");
    },
    []
  );

  const onChangeFolderNameTextField = useCallback(
    (
      event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
      if (newValue?.length === 0) {
        setFolderNameError(true);
      } else {
        setProjectExist(false);
        setFolderNameError(false);
      }
      setFolderName(newValue || "");
    },
    []
  );

  const onChangeDateField = useCallback(
    (
      event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
      setCompletionDate(newValue || "");
    },
    []
  );

  function onChangeMultiLine(
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) {
    setDescription(newValue || "");
  }

  const onChangeClientNumber = useCallback(
    (
      event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
      const numericValue = (newValue || "").replace(/\D/g, "");
      setClientNumber(numericValue ? Number(numericValue) : undefined);
    },
    []
  );

  const onChangeClientMatter = useCallback(
    (
      event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
      const numericValue = (newValue || "").replace(/\D/g, "");
      setClientMatter(numericValue ? Number(numericValue) : undefined);
    },
    []
  );

  const hasChanges = () => {
    const folderNameChanged = folderName !== originalFolderName;
    const counterPartiesChanged = JSON.stringify(textFields) !== JSON.stringify(originalTextFields);
    const completionDateChanged = completionDate !== originalCompletionDate;
    const descriptionChanged = description !== originalDescription;
    const projectValueChanged = projectValue !== originalProjectValue;
    const clientNumberChanged = clientNumber !== originalClientNumber;
    const clientMatterChanged = clientMatter !== originalClientMatter;
    return folderNameChanged || counterPartiesChanged || completionDateChanged || descriptionChanged || projectValueChanged || clientNumberChanged || clientMatterChanged;
  };

  const handleSaveChanges = async () => {
    const parseProjectValue = (value: string): number => {
      if (!value || value === "$0") return 0;
      const cleanValue = value.replace(/[$,]/g, "");
      const parsed = parseFloat(cleanValue);
      return isNaN(parsed) ? 0 : parsed;
    };
    const payload = {
      projectId: props.projectId,
      projectName: folderName,
      projectValue: parseProjectValue(projectValue),
      projectOwner: projectOwner,
      projectStatus: props.status,
      counterParties: updatedTextFields.join(";"),
      estimatedCompletionDate: completionDate,
      description: description,
      lastUpdatedDate: new Date(),
      clientNumber: clientNumber,
      clientMatter: clientMatter,
    };

    if (props.onSaveChanges) {
      await props.onSaveChanges(payload);
    }
  };

  const closeProject = () => {
    props.hideModal();
  };
  return (
    <FormModal
      title={t("edit_project_details")}
      isModalOpen={props.isModalOpen}
      showModal={props.showModal}
      hideModal={props.hideModal}
      width="595px"
      height="auto"
      cancelButton={true}
      disableScroll
      TitleBackgroundColor="linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)"
      TitleColor={colorPallete.black1}
      style={{
        borderRadius: "8px",
        background: "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)",
        }}
     >
      <VerticalStack
        style={{
          width: "100%",
          justifyContent: "space-between",
          background: "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)",
          padding: "0px 12px 20px",
          overflow: "hidden",
          height: "auto",
        }}
      >
        <VerticalStack
          style={{
            width: "100%",
            gap: "8px",
            padding: "15px",
            backgroundColor: "white",
            borderRadius: "8px 8px 0 0",
            overflow: "auto",
            maxHeight: "calc(620px - 150px)",
          }}
        >
          <Stack>
            <Label required htmlFor="folderName" style={styles.label}>
              {t("project_name")}
            </Label>
            <TextField
              styles={{
                root: {
                  height: "44px",
                  backgroundColor: "#F8F8F8",
                  borderRadius: "8px",
                  width: "100%",
                  padding: "5px",
                  border: "1px solid #E0E0E0",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontFamily: "Poppins",
                },
                field: {
                  backgroundColor: "#F8F8F8",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontFamily: "Poppins",

                  selectors: {
                    "::placeholder": {
                      color: "#717070",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "Poppins",
                    },
                  },
                },
              }}
              borderless
              id="folderName"
              value={folderName}
              onChange={onChangeFolderNameTextField}
              placeholder={String(t("project_name"))}
            />

            {folderNameError && (
              <Text style={{ color: colorPallete.btRed }}>
                {t("project_name_required")}
              </Text>
            )}
            {projectExist && (
              <Text style={{ color: colorPallete.btRed }}>
                {t("project_already_exist")}
              </Text>
            )}
          </Stack>
          <Stack>
            <Label required htmlFor="project Owner" style={styles.label}>
              {t("project_owner")}
            </Label>
            <div
              style={{
                backgroundColor: "#F8F8F8",
                width: "100%",
                height: "44px",
                borderRadius: "8px",
              }}
            >
              <MailTextBox
                initial={[]}
                selected="reply"
                placeholder={props.projectOwner || t("project_owner_email")}
                styles={{
                  input: {
                    backgroundColor: "#F8F8F8",
                    // width: "445px",
                    border: "none",
                    outline: "none",
                    outlineColor: "inherit",
                    cursor: "not-allowed",
                    pointerEvents: "none",
                    marginLeft: 0,

                    selectors: {
                      "::placeholder": {
                        color: "#323232",
                        opacity: 0.6,
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                      },
                    },
                  },
                  root: {
                    border: "1px solid #E0E0E0",
                    backgroundColor: "#F8F8F8",
                    padding: "1%",
                    height: "maxContent",
                    borderRadius: "8px",
                    color: "#323232",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                    selectors: {
                      "div.ms-BasePicker-text::after": {
                        border: "none",
                        outline: "none",
                      },
                    },
                  },
                  itemsWrapper: {
                    border: "none",
                  },
                  text: {
                    border: "none",
                    outline: "none",
                    selectors: {
                      ".ms-BasePicker-text::after": {
                        border: "none",
                        outline: "none",
                      },
                    },
                  },
                  screenReaderText: {},
                } as any}
                onPersonaData={setCurrentSelectedItems}
                error={setProjectOwnerError}
                item={setProjectOwner}
                message={setErrorMesssage}
                project={true}
              />
            </div>
            {projectOwnerError === true && (
              <Text style={{ color: colorPallete.btRed }}>
                {t(errorMesssage)}
              </Text>
            )}
          </Stack> 
          <Stack>
            <HorizontalStack
              horizontalAlign="space-between"
              style={{
                display: "flex",
                alignItems: "center",
                paddingRight: "8px",
              }}
            >
              <Label required htmlFor="counterParty" style={styles.label}>
                {t("counter_party")}
              </Label>
              <IconButton
                iconProps={{ iconName: "CircleAdditionSolid" }}
                onClick={addCounterPartyField}
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "",
                  marginRight: "1%",
                  color: "#2B579A",
                }}
              />
            </HorizontalStack>
            {textFields.map((value, index) => (
              <React.Fragment key={index}>
                {index !== 0 ? (
                  <>
                    <HorizontalStack
                      horizontalAlign="space-between"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "8px",
                      }}
                    >
                      <Label htmlFor="counterParty" style={styles.label}>
                        {t("counter_party")}
                      </Label>
                    </HorizontalStack>
                  </>
                ) : null}
                <div
                  key={index}
                  style={{
                    display: "flex",
                    width: "100%",
                    backgroundColor: "#F8F8F8",
                    height: "47px",
                    borderRadius: "8px",
                    alignItems: "center",
                    border: "1px solid #E0E0E0",
                  }}
                >
                  <TextField
                    styles={{
                      root: {
                        height: "44px",
                        backgroundColor: "#F8F8F8",
                        borderRadius: "8px",
                        width: "100%",
                        padding: "5px",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                      },
                      field: {
                        backgroundColor: "#F8F8F8",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                        selectors: {
                          "::placeholder": {
                            color: "#717070",
                            fontSize: "16px",
                            fontWeight: 400,
                            lineHeight: "24px",
                            fontFamily: "Poppins",
                          },
                        },
                      },
                    }}
                    borderless
                    id="counterParty"
                    value={value}
                    onChange={(e) =>
                      handleTextFieldChange(index, e.currentTarget.value)
                    }
                    placeholder={String(t("counter_party"))}
                  />
                  {index !== 0 && (
                    <>
                      <svg
                        width="2"
                        height="24"
                        viewBox="0 0 2 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1 0.5V23.5" stroke="#E0E0E0" />
                      </svg>
                      <Stack
                        onClick={() => removeTextField(index)}
                        style={{ padding: "15px", cursor: "pointer" }}
                      >
                        <svg
                          width="9"
                          height="3"
                          viewBox="0 0 9 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.09091 0.579545V2.45455H0.454545V0.579545H8.09091Z"
                            fill="#717070"
                          />
                        </svg>
                      </Stack>
                    </>
                  )}
                </div>
              </React.Fragment>
            ))}

            {counterPartyError && (
              <Text style={{ color: colorPallete.btRed }}>
                {t("counter_party_required")}
              </Text>
            )}
          </Stack>

          <HorizontalStack
            style={{
              width: "100%",
              gap: "12px",
            }}
          >
            <Stack style={{ width: "50%" }}>
              <Label htmlFor="clientNumber" style={styles.label}>
                {t("client_number")}
              </Label>
              <TextField
                styles={{
                  root: {
                    height: "44px",
                    backgroundColor: "#F8F8F8",
                    borderRadius: "8px",
                    width: "100%",
                    padding: "5px",
                    border: "1px solid #E0E0E0",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                  },
                  field: {
                    backgroundColor: "#F8F8F8",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                    selectors: {
                      "::placeholder": {
                        color: "#717070",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                      },
                    },
                  },
                }}
                borderless
                inputMode="numeric"
                id="clientNumber"
                value={clientNumber?.toString()}
                onChange={onChangeClientNumber}
                placeholder="000000"
              />
            </Stack>
            
            <Stack style={{ width: "50%" }}>
              <Label htmlFor="clientMatter" style={styles.label}>
                {t("client_matter")}
              </Label>
              <TextField
                styles={{
                  root: {
                    height: "44px",
                    backgroundColor: "#F8F8F8",
                    borderRadius: "8px",
                    width: "100%",
                    padding: "5px",
                    border: "1px solid #E0E0E0",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                  },
                  field: {
                    backgroundColor: "#F8F8F8",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                    selectors: {
                      "::placeholder": {
                        color: "#717070",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                      },
                    },
                  },
                }}
                borderless
                inputMode="numeric"
                placeholder="000000"
                id="clientMatter"
                value={clientMatter?.toString()}
                onChange={onChangeClientMatter}
              />
            </Stack>
          </HorizontalStack>
          
          <HorizontalStack
            style={{
              width: "100%",
              gap: "12px",
            }}
          >
            <Stack style={{ width: "50%" }}>
              <Label htmlFor="projectValue" style={styles.label}>
                {t("project_value")}
              </Label>
              <TextField
                styles={{
                  root: {
                    height: "44px",
                    backgroundColor: "#F8F8F8",
                    borderRadius: "8px",
                    width: "100%",
                    padding: "5px 3px",
                    border: "1px solid #E0E0E0",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                  },
                  field: {
                    backgroundColor: "#F8F8F8",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                    textTransform: "uppercase",
                    selectors: {
                      "::placeholder": {
                        color: "#717070",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                        textTransform: "uppercase",
                      },
                    },
                  },
                }}
                borderless
                inputMode="numeric"
                id="estimatedClosingValue"
                 value={
                   !projectValue || projectValue === "0"
                     ? "$0"
                     : NumberWithCommas(projectValue)
                 }
                onChange={onChangeProjectValue}
              />
            </Stack>
            
            <Stack style={{ width: "50%" }}>
              <Label htmlFor="completionDate" style={styles.label}>
                {t("completion_date")}
              </Label>
              <TextField
                styles={{
                  root: {
                    height: "44px",
                    backgroundColor: "#F8F8F8",
                    borderRadius: "8px",
                    width: "100%",
                    padding: "5px 3px",
                    border: "1px solid #E0E0E0",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                  },
                  field: {
                    backgroundColor: "#F8F8F8",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Poppins",
                    textTransform: "uppercase",
                    selectors: {
                      "::placeholder": {
                        color: "#717070",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        fontFamily: "Poppins",
                        textTransform: "uppercase",
                      },
                    },
                  },
                }}
                borderless
                id="completionDate"
                value={completionDate}
                onChange={onChangeDateField}
                placeholder={"MM/DD/YYYY"}
                type="date"
              />
            </Stack>
          </HorizontalStack>
          <Stack>
            <Label htmlFor="description" style={styles.descriptionLabel}>
              {t("description")}
            </Label>
            <TextField
              styles={{
                root: {
                  height: "90px",
                  backgroundColor: "#F8F8F8",
                  borderRadius: "8px",
                  width: "100%",
                  padding: "5px",
                  border: "1px solid #E0E0E0",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontFamily: "Poppins",
                },
                field: {
                  backgroundColor: "#F8F8F8",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontFamily: "Poppins",
                  height: "80px",
                  selectors: {
                    "::placeholder": {
                      color: "#717070",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "Poppins",
                    },
                  },
                },
              }}
              borderless
              multiline={true}
              onChange={onChangeMultiLine}
              id="description"
              value={description}
              placeholder={String(t("project_description"))}
              resizable={false}
            />
          </Stack>
        </VerticalStack>
        <VerticalStack>
          <Stack className="horizontalLine"></Stack>
          <HorizontalStack
            style={{
              justifyContent: "end",
              alignSelf: "end",
              height: "20%",
              marginRight: "0px",
              marginTop: "0%",
              gap: "10px",
              backgroundColor: "white",
              width: "100%",
              borderRadius: "0 0 8px 8px",
              padding: "10px 15px",
            }}
            horizontalAlign="end"
            styles={buttonStackStyles}
            tokens={horizontalStackTokens}
          >
            <Text
            className="createButton"
              style={{
                ...styles.createButton,
                backgroundColor:
                  hasChanges() &&
                  folderName?.length !== 0 &&
                  updatedTextFields[0]?.length !== 0
                    ? "#18468F"
                    : "#EAEAEA",

                color:
                  hasChanges() &&
                  folderName?.length !== 0 &&
                  updatedTextFields[0]?.length !== 0
                    ? "#F4F4F4"
                    : "#717070",
                textAlign: "center",
                cursor: hasChanges() &&
                  folderName?.length !== 0 &&
                  updatedTextFields[0]?.length !== 0
                    ? "pointer"
                    : "not-allowed",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) => {
                if (hasChanges() &&
                    folderName?.length !== 0 &&
                    updatedTextFields[0]?.length !== 0) {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = "#18468F";
                  e.currentTarget.style.border = "1px solid #18468F";
                }
              }}
              onMouseLeave={(e) => {
                if (hasChanges() &&
                    folderName?.length !== 0 &&
                    updatedTextFields[0]?.length !== 0) {
                  e.currentTarget.style.backgroundColor = "#18468F";
                  e.currentTarget.style.color = "#F4F4F4";
                  e.currentTarget.style.border = "1px solid transparent";
                }
              }}
              onClick={() => {
                if (hasChanges() &&
                    folderName?.length !== 0 &&
                    updatedTextFields[0]?.length !== 0) {
                  handleSaveChanges();
                }
              }}
            >
              {t("save_changes")}
            </Text>
            <Text
              className="cancelButton"
              style={{ ...styles.cancelButton, textAlign: "center" }}
              onClick={() => {
                closeProject();
              }}
              onMouseEnter={() => {}}
            >
              {t("cancel")}
            </Text>
          </HorizontalStack>
        </VerticalStack>
      </VerticalStack>
      {showSuccessPopup && (
        <Popup
          isOpen={showSuccessPopup}
          title={t("success")}
          iconName={<SuccessIcon />}
          contentTitle=""
          content={popupMessage}
          customContent=""
          buttons={[]}
          onClose={() => setShowSuccessPopup(false)}
        />
      )}
      
      {showErrorPopup && (
        <Popup
          isOpen={showErrorPopup}
          title={t("error")}
          iconName={<ErrorIcon />}
          contentTitle={t("error")}
          content={popupMessage}
          customContent=""
          buttons={[]}
          onClose={() => setShowErrorPopup(false)}
        />
      )}
    </FormModal>
  );
};

const styles = {
  label: {
    color: colorPallete.black1,
    fontSize: "14px",
    fontWeight: "700",
    fontFamily: "Poppins",

    lineHeight: "20px",
  },
  descriptionLabel: {
    color: colorPallete.black1,
    fontSize: "14px",
    fontWeight: "700",
    fontFamily: "Poppins",
    lineHeight: "20px",
  },
  createButton: {
    borderRadius: "4px",
    padding: "12px 24px",
    fontSize: "14px",
    lineHeight: "16px",
    fontFamily: "Poppins",
    fontWeight: "500",
    alignItems: "center",
    minWidth: "fit-content",
    height: "40px",
    gap: "10px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "#E4E8EC",
    color: colorPallete.black1,
    borderRadius: "4px",
    minWidth: "120px",
    height: "40px",
    padding: "12px 24px",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    fontFamily: "Poppins",
    cursor: "pointer",
  },
};
